import { createContext, useContext } from "react"
import type { AutoPilotDef } from "../registry"

export const APContext = createContext<AutoPilotDef | null>(null)

export function useAP(): AutoPilotDef {
  const ap = useContext(APContext)
  if (!ap) throw new Error("useAP must be used inside AutoPilotShell")
  return ap
}

/** Alias that returns { ap } for components that prefer destructuring. */
export function useAPContext(): { ap: AutoPilotDef } {
  return { ap: useAP() }
}
